/**
 * Block 1.
 *
 * @see https://developer.wordpress.org/block-editor/how-to-guides/block-tutorial/writing-your-first-block-type/
 */
 import { __ } from '@wordpress/i18n';
 import { registerBlockType } from '@wordpress/blocks';



/**
 * Internal dependencies
 */
import edit from './edit';
import save from './save';
import PtlIcon from './icons';



// //import deprecated from './deprecated';

// // import metadata from './block.json';


let metadata = {
    title: __('Block Timeline'),
    icon: PtlIcon,
    category: 'layout',
    keywords: [
        __('timeline'),
        __('block'),
        __('history'),
        __('event'),
        __('post'),
        __('create timeline'),
    ],
    attributes: {
        TimeLine_heading: {
            type: "string",
            default: 'National Holidays'
        },         
        CardColor: {
            type: "string",
            default: '#fffff'
        },          
        CardTextColor: {
            type: "string",
            default: '#fffff'
        },         
        CardLineColor: {
            type: "string",
            default: '#4285f4'
        }, 
        info: {
           type: 'array',
           selector: '.timeline-section'
        },        
        infoDown: {
           type: 'array',
           selector: '.timeline-section'
        },
        titleFirst: {
            type: "string",
            default: 'Martin Luther King Jr. Day'
        },  
        iconFirst: {
            type: "string",
            default: 'flag-usa'
        },           
        prefixiconFirst: {
            type: "string",
            default: 'fas'
        },           
        bgcolorFirst: {
            type: "string",
            default: '#778beb'
        },        
        start: {
            type: "string",
            default: 'Start'
        },        
        end: {
            type: "string",
            default: 'End'
        },
        contentFirst: {
            type: "string",
            default: 'Martin Luther King Jr. Day is a federal holiday in the United States that is observed to honor the achievements of Martin Luther King'
        },
         mediaIDFirst: {
            type: 'number',
            default: 1
        },
        mediaURLFirst: {
            type: 'string',
            attribute: 'src',
            default: PTL_BLOCK.ptl_path+'admin/blocks/assets/images/Martin-Luther-King-Jr.-Day.jpg'
        },
        yearFirst: {
            type: "string",
            default: '17 Jan'
        },
        titleSec: {
            type: "string",
            default: 'Washington’s Birthday'
        },
        bgcolorSec: {
            type: "string",
            default: '#f5cd79'
        },
        iconSec: {
            type: "string",
            default: 'flag-usa'
        },
        prefixiconSec: {
            type: "string",
            default: 'fas'
        },  
        contentSec: {
            type: "string",
            default: 'Washington’s Birthday is a holiday in the United States which is celebrated to honor both George Washington and Abraham Lincoln'
        },
        mediaIDSec: {
            type: 'number',
            default: 2
        },
        mediaURLSec: {
            type: 'string',
            attribute: 'src',
            default: PTL_BLOCK.ptl_path+'admin/blocks/assets/images/Washingtons-Birthday.jpg'
        },
        yearSec: {
            type: "string",
            default: '20 Feb'
        },
    },
    /**
     * @see ./edit.js
     */
    edit,
    
    /**
     * @see ./save.js
     */
    save,

};

registerBlockType( 'post-timeline/block', metadata );




   